import { MutationTree } from "vuex";
import { IAssetsState, getDefaultAssetsState } from ".";
import { IAsset } from "@/models/asset";

export const mutations: MutationTree<IAssetsState> = {
    setAssets(state, payload: IAsset[]) {
        state.error = null;
        state.assetsList = [...payload];
    },
    setSelectedAsset(state, payload: IAsset) {
        state.selectedAsset = payload;
    },
    setAssetsError(state, payload: any) {
        state.error = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultAssetsState());
    },
};
